import { initializeOffsetFields } from "./offset-fields";
import { initializeCloneFields } from "./clone-fields";

initializeCloneFields();
initializeOffsetFields();
